import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "z-10 w-full" }
const _hoisted_2 = { class: "relative mt-1" }
const _hoisted_3 = { class: "block truncate" }
const _hoisted_4 = { class: "flex absolute inset-y-0 right-0 items-center pr-2 pointer-events-none" }
const _hoisted_5 = {
  key: 0,
  class: "flex absolute inset-y-0 left-0 items-center pl-3 text-amber-600"
}

import { computed, PropType, ref } from "vue";
import {
  Listbox,
  ListboxButton,
  ListboxOptions,
  ListboxOption,
} from "@headlessui/vue";
import { CheckIcon, SelectorIcon } from "@heroicons/vue/solid";
import { ICategory } from "@/interfaces/ICategory";


export default /*#__PURE__*/_defineComponent({
  props: {
  categories: {
    type: Array as PropType<ICategory[]>,
    default: () => [
      {
        id: 0,
        name: "All",
      },
    ],
  },
},
  emits: ["change"],
  setup(__props, { emit }) {

const props = __props




const activeCategoryId = ref<number>(0);
const activeCategory = computed(() =>
  props.categories.find(category => category.id === activeCategoryId.value)
);

const onChangeCategory = (id: number) => emit("change", id);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Listbox), {
      modelValue: activeCategoryId.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeCategoryId).value = $event)),
      class: "z-10"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(ListboxButton), { class: "relative py-2 pr-10 pl-3 w-full text-left bg-white rounded-lg border-gray-400 shadow-md cursor-default sm:text-sm" }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(activeCategory) ? _unref(activeCategory).name : "All"), 1),
              _createElementVNode("span", _hoisted_4, [
                _createVNode(_unref(SelectorIcon), {
                  class: "w-5 h-5 text-gray-400",
                  "aria-hidden": "true"
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_Transition, {
            "leave-active-class": "transition duration-100 ease-in",
            "leave-from-class": "opacity-100",
            "leave-to-class": "opacity-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(ListboxOptions), { class: "overflow-auto absolute py-1 mt-1 w-full max-h-60 text-base bg-white rounded-md ring-1 ring-black ring-opacity-5 shadow-lg sm:text-sm focus:outline-none" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.categories, (catagory) => {
                    return (_openBlock(), _createBlock(_unref(ListboxOption), {
                      key: catagory.name,
                      value: catagory.id,
                      as: "template",
                      onClick: () => onChangeCategory(catagory.id ?? 0)
                    }, {
                      default: _withCtx(({ active, selected }) => [
                        _createElementVNode("li", {
                          class: _normalizeClass([
                  active ? 'text-primary' : 'text-gray-900',
                  'cursor-default select-none relative py-2 pl-10 pr-4',
                ])
                        }, [
                          _createElementVNode("span", {
                            class: _normalizeClass([
                    selected ? 'font-medium' : 'font-normal',
                    'block truncate',
                  ])
                          }, _toDisplayString(catagory.name), 3),
                          selected
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                                _createVNode(_unref(CheckIcon), {
                                  class: "w-5 h-5",
                                  "aria-hidden": "true"
                                })
                              ]))
                            : _createCommentVNode("", true)
                        ], 2)
                      ]),
                      _: 2
                    }, 1032, ["value", "onClick"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})